<div class="ui basic segment">
    <app-header title="performance.goal-index.employeeIndexTitle" [menuService]="tabMenuService">
        <div class="buttons">
            <ui-button *permission="createPermission" [routerLink]="['/performance/goals/create']" type="primary">
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                <span>{{ 'performance.goal-index.addGoal' | translate }}</span>
            </ui-button>
        </div>
    </app-header>

    <app-table [table]="table">
        <app-empty-state label="performance.goal-index.noGoalsFound" src="/assets/illustrations/flag.png">
        </app-empty-state>
    </app-table>
</div>
